const user_os = [
  {
    name: 'android',
    label: 'Android',
  },
  {
    name: 'iOS',
    label: 'iOS',
  },
  {
    name: 'windows',
    label: 'Windows',
  },
];

export default user_os;
